import { useState } from "react";
import RadixDialog from "../../common/dialogs/RadixDialog";
import Button from "../../common/Button";
import classNames from "./PinDialog.module.css";

const PinDialog = (props: { onSubmit: (pin: string) => void }) => {
  const [pin, setPin] = useState("");

  return (
    <RadixDialog
      title={"Event pin"}
      open={true}
      className={classNames.Content}
      unclosable={true}
      content={
        <>
          <div>
            <h2>Enter pin</h2>
            <input
              type="text"
              placeholder="Ex. 1234"
              onChange={(e) => setPin(e.target.value)}
              value={pin}
            />
          </div>
          <Button disabled={!pin.length} onClick={() => props.onSubmit(pin)}>
            Confirm
          </Button>
        </>
      }
    />
  );
};

export default PinDialog;
